import React from "react";

import Button from "react-bootstrap/Button";
import ObjectUtils from "../../../utils/ObjectUtils";
import Progress from "./Progress";
/* eslint-disable react/sort-comp */
import { faAngleLeft, faAngleRight, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import { ButtonGroup, ButtonToolbar } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { visibleCollection } from "../../../utils/TriggerUtil";

const { findObjectIndexInArray, getDeepProperty } = ObjectUtils;
const LEFT = -1;
const RIGHT = 1;

/**
 * The component represents SurveyFooter.
 */
const SurveyFooter = ({
  surveyTemplate,
  surveyResult,
  triggerState,
  readonly,
  readOnlyByPermissions,
  surveyCurrentPage,
  confirmLabel,
  sendingDataIsInProgress,
  jumpToPage,
  onConfirm,
  showDialog,
  hidePreviewSurvey,
  saveSurveyResultAndStayInRunner
}) => {
  const location = useLocation();

  const move = (direction = 1) => {
    let visiblePages = visibleCollection(surveyTemplate.pages, triggerState);
    let currIndex = findObjectIndexInArray(visiblePages, "name", surveyCurrentPage);
    currIndex = currIndex >= 0 && currIndex < visiblePages.length ? currIndex : 0;
    let next =
      currIndex + direction < visiblePages.length && currIndex + direction >= 0 ? currIndex + direction : currIndex;
    jumpToPage(visiblePages[next].name);
  };

  const nextPage = () => {
    move(RIGHT);
  };

  const prevPage = () => {
    move(LEFT);
  };

  const handleConfirm = () => {
    let path = location.pathname;
    path === "/userArea/build" || path === "/userArea/templates"
      ? hidePreviewSurvey()
      : showDialog(
          null,
          onConfirm,
          "dialog.leave.report",
          "dialog.leave.runner",
          "dialog.leave.runner.details",
          "dialog.leave.runner.overview",
          <FontAwesomeIcon icon={faInfoCircle} size="2x" />,
          saveSurveyResultAndStayInRunner
        );
  };

  const visiblePages = visibleCollection(surveyTemplate.pages, triggerState);
  let currIndex = findObjectIndexInArray(visiblePages, "name", surveyCurrentPage);
  currIndex = currIndex >= 0 && currIndex < visiblePages.length ? currIndex : 0;

  const currPage = getDeepProperty(visiblePages, currIndex);

  if (surveyTemplate) {
    const isLast = currIndex >= visiblePages.length - 1;
    const isFirst = currIndex === 0;

    return (
      <div className={"d-flex align-items-center justify-content-around w-100 gap-lg flex-fill mx-lg-5 mx-sm-2"}>
        {currPage && (
          <Progress
            surveyResult={surveyResult}
            triggerState={triggerState}
            visiblePages={visiblePages}
            surveyCurrentPage={currPage}
            pageIndex={currIndex}
          />
        )}
        <ButtonToolbar>
          <ButtonGroup className={"gap-lg me-2"}>
            {!isFirst && (
              <Button variant="light" onClick={() => prevPage()}>
                <FontAwesomeIcon icon={faAngleLeft} />
              </Button>
            )}
            {!isLast && (
              <Button variant="light" onClick={nextPage}>
                <FontAwesomeIcon icon={faAngleRight} />
              </Button>
            )}
          </ButtonGroup>
          <Button
            disabled={sendingDataIsInProgress || readonly || readOnlyByPermissions}
            onClick={handleConfirm}
          >
            {confirmLabel}
          </Button>
        </ButtonToolbar>
      </div>
    );
  }

  return null;
};

SurveyFooter.propTypes = {
  surveyCurrentPage: PropTypes.string,
  surveyTemplate: PropTypes.object.isRequired,
  surveyResult: PropTypes.object.isRequired,
  jumpToPage: PropTypes.func,
  onConfirm: PropTypes.func,
  showDialog: PropTypes.func,
  confirmLabel: PropTypes.string,
  triggerState: PropTypes.array,
  readonly: PropTypes.bool,
  readOnlyByPermissions: PropTypes.bool,
  sendingDataIsInProgress: PropTypes.bool,
  hidePreviewSurvey: PropTypes.func,
  saveSurveyResultAndStayInRunner: PropTypes.func
};

export default SurveyFooter;
